module.exports = __webpack_public_path__ + "static/media/和谐民欣.1676358d.jpg";